import axios from 'axios';
import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';

export default function FundStatistics({ stats, loading }) {
  return (
    <section className={'shadow p-5 bg-white'}>
      <div>
        <h3 className={'font-medium text-base lg:text-lg'}>
          Total Wallet Funds
        </h3>

        {loading ? (
          <LoadingSpinner color={'text-yellow-500'} />
        ) : (
          <div className={'mt-3'}>
            <div className={'flex flex-row justify-between items-center'}>
              <div>
                {stats &&
                  Object.keys(stats).map((item, index) => (
                    <h3 key={index} className={'text-base text-gray-500'}>
                      {item}
                    </h3>
                  ))}
              </div>
              <div>
                {stats &&
                  Object.values(stats).map((item, index) => (
                    <h3 key={index} className={'text-base text-gray-800'}>
                      {item}
                    </h3>
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
